import React, { useEffect, useState } from 'react';
// import { InboxOutlined } from '@ant-design/icons';
import { Typography, UploadProps } from 'antd';
import { Upload } from 'antd';
import { styled } from 'styled-components';
import { ItemRender } from 'antd/es/upload/interface';
import { DeleteTwoTone } from "@ant-design/icons";
import { Stack } from 'components/Stack';

const FILE_ICON = process.env.PUBLIC_URL + "/images/file-arrow-up-solid-icon.svg";

const { Dragger } = Upload;


interface UploadFileProps {
  onChange: (file: any) => void;
  allowedTypes: (".png" | ".jpeg" | ".jpg" | ".gif" | ".csv" | ".svg" | ".pdf")[];
  maxCount?: number;
}

const UploadFile: React.FC <UploadFileProps> = ({
  onChange,
  allowedTypes,
  maxCount = 5
}) => {
  const [fileList, setFileList] = useState<any>(null)
  const [errorMessage, setErrorMessage] = useState("")
  
  const handleViewDoctorFile = async (file: any) => {
    const fileBlob = new Blob([file.originFileObj], {
      type: file.type,
    });
    const fileURL = URL.createObjectURL(fileBlob);
    window.open(fileURL);
  };

  const itemRender: ItemRender<any> = (existingComponent, file, fileList, action) => {
    return (
      <Stack direction='row' placeContent="space-between" style={{ marginTop: 20 }}>
        <Typography
          onClick={() => console.log(action.preview())}
          style={{ color: "#00b7ff", cursor: "pointer" }}
        >
          {file.name}
        </Typography>
        <DeleteTwoTone
          onClick={() => action.remove()}
          rev="some-rev-value"
          twoToneColor="#1F65C0"
          style={{ fontSize: "20px" }}
        />
      </Stack>
    );
  };

  const props: UploadProps = {
    name: 'file',
    multiple: true,
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
    itemRender: itemRender,
    onChange: (file) => {
      let newFileList = file.fileList
      const type = file.file.name.split(".")
      const lastItem = `.${type[`${type.length - 1}`]}`;

      const isExistFileType = allowedTypes.find(allowedType => {
        return allowedType === lastItem ? true : false
      })

      if (!isExistFileType) {
        return setErrorMessage(`You can upload only ${allowedTypes.join(', ')}!`);
      }

      if (file.fileList.length === maxCount) {
        return setErrorMessage(`Maximum upload limit is ${maxCount} only.`)
      }
      
      setFileList(newFileList)
      onChange(file)
    },
    fileList: fileList,
    maxCount: maxCount,
    customRequest: () => {
      return true;
    }
  };

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        setErrorMessage("")
      }, 3000);
    }
  }, [errorMessage])
  
  return (
    <Stack direction='column'>
      <StyledDragger {...props} 
        onPreview={(file) => {
          handleViewDoctorFile(file);
        }}
      >
        <img src={FILE_ICON} alt="FILE_ICON"/>
        <Typography>
          Drag and drop, or <span style={{ color: "#005CC7" }}>browse </span>your files
        </Typography>
      </StyledDragger>
      {errorMessage && <Typography style={{ color: "red" }}>{errorMessage}</Typography> } 
    </Stack>
  )
};

export default UploadFile;

const StyledDragger = styled(Dragger)`
  flex: 1;
  .ant-upload {
    height: 178px !important;
    border: 1px dashed #DFE5EB;

    &:hover {
      border: 1px dashed #DFE5EB !important;
    }
  }

  .ant-upload-list {
    & {
      .ant-upload-list-item {
        margin-top: 0px;
        color: #33C6F4;
      }
    }

    & .ant-upload-icon {
      display: none;
    }
  }
`